import '../sections/product';
import '../components/infoCardController';
import scrollToElement from 'UTILS/window/scrollToElement';

const selectors = {
  mainImage: '#main-image',
  variantImages: 'img[data-extra-image-name]',
  supplementAnchorLink: '[data-supplement-anchor-link]',
  supplementSection: '#supplements',
};

// Info Section Slider
$('.info-slider').slick({
  autoplay: false,
  arrows: false,
  dots: false,
  swipe: false,
  fade: true,
  draggable: false,
});

document.querySelectorAll('.info-facts-blade [data-info-index]').forEach(function (item) {
  item.addEventListener('click', function (e) {
    e.preventDefault();

    if ($(item).hasClass('active')) {
      return;
    }

    document.querySelectorAll('.info-facts-blade [data-info-index]').forEach(function (item) {
      item.classList.remove('active');
    });

    var index = item.dataset.infoIndex;
    $('.info-slider').slick('slickGoTo', index);

    item.classList.add('active');
  });
});

const updateMainImage = (event) => {
  const target = event.target;
  const variantId = target.value;

  if (!variantId) return;

  const mainImage = document.querySelector(selectors.mainImage);
  // Updating the image
  const selectedOption = target.querySelector(`option[value="${variantId}"]`);
  const text = selectedOption.text;

  const variantImages = document.querySelectorAll(selectors.variantImages);
  Array.from(variantImages).forEach((item) => {
    var lowercase = item.dataset.extraImageName.toLowerCase();
    if (lowercase.indexOf(text.toLowerCase()) != '-1') {
      const date = new Date();
      const imageSrc = `${item.src}&t=${date.getTime()}`;
      mainImage.setAttribute('src', imageSrc);
    }
  });
};

function closeAllTabs(thisTab) {
  const tabs = document.querySelectorAll('.tabs .tab');

  Array.from(tabs).forEach((tab) => {
    if (tab === thisTab) return;
    tab.classList.remove('active');
  });
}

document.querySelectorAll('.tabs .tab-label').forEach(function (item) {
  item.addEventListener('click', function (e) {
    e.preventDefault();
    const tab = this.closest('.tab');
    // Toggle Tab class
    closeAllTabs(tab);
    $(tab).toggleClass('active');

    // Toggle Aria Expanded Attribute
    $(this)
      .find('[aria-expanded]')
      .attr('aria-expanded', function (i, attr) {
        return attr == 'true' ? 'false' : 'true';
      });
  });
});

const handleSupplementAnchorClick = (event) => {
  const supplementAnchorLink = event.target.closest(selectors.supplementAnchorLink);

  if (!supplementAnchorLink) return;

  event.preventDefault();
  const supplementSection = document.querySelector(selectors.supplementSection);
  scrollToElement(supplementSection);
};

document.addEventListener('variantChanged', updateMainImage);
document.addEventListener('click', handleSupplementAnchorClick);
